import {Component, effect, inject, input, output, signal} from "@angular/core";
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {AggregatedAssetStateStore} from "src/app/domain/assets/aggregated-state/aggregated-asset-state.store";
import {InfoButtonComponent} from "src/app/presentation/common/info-button/info-button.component";

export interface LatLong {
  latitude: number;
  longitude: number;
}

@Component({
  selector: 'app-sample-based-location-button',
  styleUrl: './sample-based-location-button.component.css',
  templateUrl: './sample-based-location-button.component.html',
  imports: [GenericButtonComponent, InfoButtonComponent]
})
export class SampleBasedLocationButton {

  assetId = input<string>();
  locationEmitted = output<LatLong>();

  location = signal<LatLong | undefined>(undefined);
  message = signal("Be aware that the reported GPS position can deviate up to 10+ meters from the actual location. The location can differ per day.");

  private aggregatedAssetStateStore = inject(AggregatedAssetStateStore);

  constructor() {
    effect(() => {
      const assetId = this.assetId();
      if (!assetId || this.aggregatedAssetStateStore.loading()) return;

      const state = this.aggregatedAssetStateStore.entityMap()[assetId];
      if (!state) return;

      const position = state.position;
      if (!position) return;

      this.location.set({
        latitude: position[0],
        longitude: position[1]
      });
    });
  }

  emitLocation() {
    const location = this.location();
    if (!location) return;

    this.locationEmitted.emit(location);
  }
}
